import { action, observable } from 'mobx';
import * as moment from 'moment';
import { post } from './HTTPLib';

export enum SensorType {
	OXYGEN = "oxygen",
	DEPTH = "depth",
	PH = "ph",
	TEMPERATURE = "temperature",
	SALINITY = "salinity",
	WATER_CURRENT = "waterCurrent",
}

export class Reading {
	loggerId: number
	x: moment.Moment
	y: number
}

export class ChartData {
	@observable oxygen: Array<Reading> = new Array<Reading>()
	@observable depth: Array<Reading> = new Array<Reading>()
	@observable ph: Array<Reading> = new Array<Reading>()
	@observable salinity: Array<Reading> = new Array<Reading>()
	@observable waterCurrent: Array<Reading> = new Array<Reading>()
}

export class Logger {
	@observable id: number = 0
	@observable name: string = ''
	@observable chartLabel: string = ''
	@observable colour: string = '#000000'
	@observable timezone: string = ''
	@observable oxygen: number = 0;
	@observable oxygenCalibrated: boolean = false;
	@observable temperature: number = 0;
	@observable depth: number = 0;
	@observable depthCalibrated: boolean = false;
	@observable monitorDepth: boolean = false;
	@observable online: boolean = false;
	@observable timestamp: moment.Moment = moment();
	@observable originAppHostId: number = 0;
	@observable viewId: string = '';
	@observable lastUpdated: string = 'last update unknown';
	@observable oxygenOriginalReading: number = 0;
	@observable depthOriginalReading: number = 0;
	@observable monitorOxygen: boolean = false;
	@observable monitorTemperature: boolean = false;
	@observable monitorPH: boolean = false;
	@observable monitorSalinity: boolean = false;
	@observable monitorWaterCurrent: boolean = false;
	@observable pHReading: number = 0;
	@observable salinityReading: number = 0;
	@observable waterCurrentReading: number = 0;
	@observable isOxygenCalibratable: boolean = true;
	constructor(id: number, name: string, chartLabel: string, colour: string, timezone: string, oxygen: number,
		temperature: number, online: boolean, timestamp: moment.Moment, oxygenCalibrated: boolean,
		originAppHostId: number, viewId: string, depth: number, monitorDepth: boolean, depthCalibrated: boolean, oxygenOriginalReading: number, depthOriginalReading: number,
		monitorTemperature: boolean, monitorOxygen: boolean, monitorPH: boolean, pHReading: number,
		monitorSalinity: boolean, salinityReading: number, monitorWaterCurrent: boolean, waterCurrentReading: number,
		isOxygenCalibratable: boolean = true) {
		this.id = id;
		this.name = name;
		this.chartLabel = chartLabel;
		this.colour = colour;
		this.timezone = timezone;
		this.oxygen = oxygen;
		this.temperature = temperature;
		this.online = online;
		this.timestamp = moment(timestamp);
		this.lastUpdated = this.timestamp.clone().subtract(10, 'seconds').fromNow() // Wanna avoid it saying 'in a few seconds'
		this.oxygenCalibrated = oxygenCalibrated;
		this.originAppHostId = originAppHostId;
		this.viewId = viewId;
		this.depth = depth;
		this.monitorDepth = monitorDepth;
		this.depthCalibrated = depthCalibrated;
		this.oxygenOriginalReading = oxygenOriginalReading;
		this.depthOriginalReading = depthOriginalReading;
		this.monitorTemperature = monitorTemperature;
		this.monitorOxygen = monitorOxygen;
		this.monitorPH = monitorPH;
		this.pHReading = pHReading;
		this.monitorSalinity = monitorSalinity;
		this.salinityReading = salinityReading;
		this.monitorWaterCurrent = monitorWaterCurrent;
		this.waterCurrentReading = waterCurrentReading;
		this.isOxygenCalibratable = isOxygenCalibratable;
	}

	@action
	calibrate(pin: string, sensorType: SensorType, calibrationPoint?: number) {
		return post(`/api/views/${this.viewId}/loggers/${this.id}/calibration`, {
			pin,
			sensorType,
			calibrationPoint,
		})
	}

}

export class Cage {
	@observable id: number = 0
	@observable name: string = ''
	@observable location: string = ''
	@observable loggers: Array<Logger> = []
	constructor(id: number, name: string, location: string, loggers: Array<Logger>) {
		this.id = id
		this.name = name
		this.location = location
		this.loggers = loggers
	}
}

export class Location {
	@observable id: number = 0
	@observable name: string = ''
	constructor(id: number, name: string) {
		this.id = id
		this.name = name
	}
}



// WEBPACK FOOTER //
// ./src/Models.tsx